import React from 'react';

const ExcelFile = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill="#185C37"
            d="M20.093 14.356 7.442 12.089v16.748c0 .765.61 1.385 1.364 1.385h21.83c.753 0 1.364-.62 1.364-1.385v-6.17l-11.907-8.311Z"
        />
        <path
            fill="#21A366"
            d="M20.093 0H8.806c-.753 0-1.364.62-1.364 1.385v6.17l12.651 7.556 6.698 2.267L32 15.11V7.556L20.093 0Z"
        />
        <path fill="#107C41" d="M7.442 7.556h12.651v7.555H7.442V7.556Z" />
        <path
            fill="#000"
            d="M16.496 6.044H7.442v18.89h9.054a1.38 1.38 0 0 0 1.364-1.386V7.43a1.38 1.38 0 0 0-1.364-1.385Z"
            opacity={0.1}
        />
        <path
            fill="#000"
            d="M15.752 6.8h-8.31v18.889h8.31a1.38 1.38 0 0 0 1.364-1.385V8.184A1.38 1.38 0 0 0 15.752 6.8Z"
            opacity={0.2}
        />
        <path
            fill="#000"
            d="M15.752 6.8h-8.31v17.378h8.31a1.38 1.38 0 0 0 1.364-1.385V8.185A1.38 1.38 0 0 0 15.752 6.8Z"
            opacity={0.2}
        />
        <path
            fill="#000"
            d="M15.008 6.8H7.442v17.378h7.566a1.38 1.38 0 0 0 1.364-1.385V8.185A1.38 1.38 0 0 0 15.008 6.8Z"
            opacity={0.2}
        />
        <path
            fill="url(#a)"
            d="M1.364 6.8h13.644c.753 0 1.364.62 1.364 1.385v13.852c0 .765-.61 1.385-1.364 1.385H1.364c-.753 0-1.364-.62-1.364-1.385V8.185C0 7.42.61 6.8 1.364 6.8Z"
        />
        <path
            fill="#fff"
            d="m4.224 19.613 2.87-4.515-2.63-4.49H6.58l1.435 2.872c.132.273.223.475.272.609h.019c.094-.218.193-.43.297-.634l1.534-2.845h1.942l-2.697 4.463 2.765 4.54h-2.066L8.424 16.46a2.662 2.662 0 0 1-.198-.42h-.025c-.048.142-.113.28-.192.407l-1.706 3.165H4.224Z"
        />
        <path
            fill="#33C481"
            d="M30.636 0H20.093v7.556H32V1.385C32 .62 31.39 0 30.636 0Z"
        />
        <path fill="#107C41" d="M20.093 15.111H32v7.556H20.093V15.11Z" />
        <defs>
            <linearGradient
                id="a"
                x1={2.844}
                x2={13.773}
                y1={5.718}
                y2={24.361}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#18884F" />
                <stop offset={0.5} stopColor="#117E43" />
                <stop offset={1} stopColor="#0B6631" />
            </linearGradient>
        </defs>
    </svg>
);

export default ExcelFile;